//  全局socket

import md5 from 'js-md5'


let lz_wsURl = {};
let cinnectNumbers = 1;
let timeoutObjs = null // 心跳计时
let GlobalScopeSocket = {} // 比分socket
 // 心跳机制
function heartCheck(){
      let  timeout = 3000; //5秒，针对不同项目设置不同时间，比如客服系统就不用那么频繁检测，股票交易所就必须很频繁
      clearTimeout(timeoutObjs);
      console.log('发送比分心跳111');
      timeoutObjs = setTimeout(()=>{
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          //onmessage拿到返回的心跳就说明连接正常
          console.log('发送比分心跳');
          GlobalScopeSocket.send(JSON.stringify({"function":"heart"}));//发送这个消息的时候，必须让后端收到消息后，立马发送一个消息，这样来回一个接收过程，就可以判断当前还没有断开连接。
          // self.serverTimeoutObj = setTimeout(function() { //如果超过一定时间还没重置，说明后端主动断开了
          //     console.log('%c [ 主动断开了 ]: ', 'color: #bf2c9f; background: pink; font-size: 13px;', '主动断开了')
          //     myselft.socket.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
          // },2000)
      }, timeout)

    }
    
    
let GlobalInfo = {
  open:function(e){
    console.log('初始化成功',lz_wsURl,cinnectNumbers);
    cinnectNumbers = 1
    heartCheck()
  },
  sucess:function(e){
    // console.log('监听比分',e);
    heartCheck()
  },
  fail:function(e){
    console.log(e);
    reconnect()
  },
  close:function(e){
    console.log(e);
    reconnect()
  }
}

//重连
function reconnect() {
    //没连接上会一直重连，设置延迟避免请求过多
    if(cinnectNumbers < 5){
      setTimeout(function() {
          GloubleSocket(lz_wsURl);
          console.log('断线重连中------------------------',cinnectNumbers,'info',lz_wsURl);
          cinnectNumbers++;
      }, 200);
    }
}

export const GloubleSocket = function(infoData,cb) {
  lz_wsURl = infoData

  let globalWs = {
    product: "lz",
    module: "global",
    roomid: 0,
    userid: infoData.userid ? infoData.userid : 0,
  }
  // ASSCI码升序排序
  var arr2 = new Array();
  var num2 = 0;
  for (var i in globalWs) {
    arr2[num2] = i;
    num2++;
  }
  var sortArr2 = arr2.sort();
  var sortObj2 = {};
  for (var i in sortArr2) {
    sortObj2[sortArr2[i]] = globalWs[sortArr2[i]];
  }



  var assci2 =
    sortArr2[0] +
    "=global" +
    "&" +
    sortArr2[1] +
    "=lz" +
    "&" +
    sortArr2[2] +
    "=0" +
    "&" +
    sortArr2[3] +
    "=" +
    globalWs.userid +
    "&" +
    "salt=12345";
  let accessToken = md5(assci2);


  if (typeof WebSocket === "undefined") {
    alert('您的浏览器不支持socket')
  } else {

    try {
      GlobalScopeSocket = new WebSocket(infoData.url + "?product=lz&module=global&roomid=0" +
        "&userid=" + globalWs.userid + "&accessToken=" + accessToken);
      GlobalScopeSocket.onopen =  GlobalInfo.open
      GlobalScopeSocket.onmessage =  GlobalInfo.sucess
      GlobalScopeSocket.onclose = GlobalInfo.close
      GlobalScopeSocket.onerror = GlobalInfo.fail
    } catch (e) {
      console.log('初始化失败',e);
    }
  }
}


export default GlobalInfo



// WEBPACK FOOTER //
// ./src/lib/scoreSocket.js